export default "__VITE_ASSET__aa8c6ab1__"